// Shared constants for listing create/edit forms
// Extracted from CreateListingPage.js to keep the main component focused on logic

export const TIMBER_SPECIES = [
  'Blackbutt', 'Spotted Gum', 'Jarrah', 'Karri', 'Messmate', 'Ironbark',
  'Pine', 'Oregon', 'Cypress', 'Cedar', 'Oak', 'Ash', 'Other'
];

export const TIMBER_TYPES = ['Hardwood', 'Softwood', 'Engineered', 'Mixed'];

export const DOOR_TYPES = ['Hollow Core', 'Solid Core', 'Panel', 'Flush', 'Glazed', 'French'];

export const BRICK_TYPES = ['Clay', 'Concrete', 'Clinker', 'Engineering', 'Face'];

export const METAL_TYPES = [
  'Steel', 'Aluminium', 'Copper', 'Brass', 'Bronze',
  'Cast Iron', 'Galvanised Steel', 'Stainless Steel'
];

export const WINDOW_GLAZING = [
  'Single Glazed', 'Double Glazed', 'Triple Glazed', 'Heritage Glass', 'Leadlight'
];

export const ROOF_PROFILES = [
  'Corrugated', 'Trimdek', 'Klip-Lok', 'Spandek', 'Custom Orb', 'Tile Profile'
];

export const CONDITIONS = [
  { id: 'excellent', name: 'Excellent', description: 'Like new, minimal wear' },
  { id: 'good', name: 'Good', description: 'Some wear, fully functional' },
  { id: 'fair', name: 'Fair', description: 'Visible wear, usable condition' },
  { id: 'salvage', name: 'Salvage', description: 'For restoration or parts' }
];

export const UNITS = [
  { id: 'piece', name: 'Piece' },
  { id: 'sqm', name: 'Square Meter' },
  { id: 'linear_meter', name: 'Linear Meter' },
  { id: 'kg', name: 'Kilogram' },
  { id: 'lot', name: 'Lot' }
];

export const USE_CATEGORIES = [
  { id: 'flooring', name: 'Flooring' },
  { id: 'cladding', name: 'Cladding' },
  { id: 'roofing', name: 'Roofing' },
  { id: 'lining', name: 'Lining' },
  { id: 'structural', name: 'Structural' },
  { id: 'ornamentation', name: 'Ornamentation' },
  { id: 'furnishing', name: 'Furnishing' },
  { id: 'fitting', name: 'Fitting' },
  { id: 'fixture', name: 'Fixture' }
];

export const FINISHES = [
  { id: 'none', name: 'None / Natural' },
  { id: 'painted', name: 'Painted' },
  { id: 'stained', name: 'Stained' },
  { id: 'varnished', name: 'Varnished' },
  { id: 'powder_coated', name: 'Powder Coated' },
  { id: 'galvanised', name: 'Galvanised' },
  { id: 'polished', name: 'Polished' },
  { id: 'other', name: 'Other' }
];

export const OBJECT_TYPES = [
  { id: 'standalone', name: 'Standalone Object/Item' },
  { id: 'carcass_interior', name: 'Carcass/Interior of Object' },
  { id: 'exterior', name: 'Exterior of Object' },
  { id: 'not_applicable', name: 'Not Applicable' }
];
